import { CSSProperties } from 'react';
import { Row, Text } from '~/commonComponents';

interface ILabelValueDisplayProps {
  label: string;
  value?: string | null;
  labelStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  containerStyle?: CSSProperties;
}

export const LabelValueDisplay = ({
  label,
  value = '',
  labelStyle,
  valueStyle,
  containerStyle,
}: ILabelValueDisplayProps) => {
  return (
    <Row flex={1} alignItems="flex-start" gap={15} style={containerStyle}>
      <Text
        fontSize={18}
        bold
        wordBreak="break-word"
        style={{
          flex: 0.4,
          ...labelStyle,
        }}
      >
        {label}
      </Text>
      <Text flex={1} wordBreak="break-word" style={valueStyle}>
        {value}
      </Text>
    </Row>
  );
};
